export const getTemplates = state => state.templates;

export const getCategoriesTree = state => state.categoriesTree;

export const getLsTemplates = state => state.lsTemplates;

export const getKeyword = (state) => state.keyword;